import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'signup',
  label: 'Signup Section',
  description: 'Registration form with phone/OTP.',
  supportedPages: ['signup'],
  variants: [{ id: 'v1', label: 'V1 (Standard)' }],
  commonFields: [{ key: 'redirectUrl', label: 'Redirect After Signup', type: 'string', default: '/account' }],
}
